// DOC-DEPS: LLM.md -> docs/ACTIVITY_MOOD_AUTO_RECOGNITION.md -> docs/ACTIVITY_LEXICON.md -> src/features/chat/README.md
import type { MoodKey } from '../../lib/moodOptions';
import { getLexicon } from './lexicon/getLexicon';
import { zhStandaloneActivityNouns } from './lexicon/activityLexicon.zh';

const zhLexicon = getLexicon('zh');
const { activity: zhActivity, mood: zhMood } = zhLexicon;

export const ZH_STANDALONE_ACTIVITY_NOUNS = zhStandaloneActivityNouns;

export const ZH_ACTIVITY_STRONG_PHRASES = [...zhActivity.strongPhrases];

export const ZH_ACTIVITY_VERBS = [...zhActivity.verbs];

export const ZH_ACTIVITY_SINGLE_VERB_PATTERNS = [
  /(起床了?|刚起床|刚睡醒)/,
  /吃[了过]?(饭|早饭|早餐|午饭|晚饭|夜宵)/,
  /复习(?!一下|会)[\u4e00-\u9fa5A-Za-z0-9·]{1,16}/,
  /学(?!会|期|校|历|到|着|过|一下)[\u4e00-\u9fa5A-Za-z0-9·]{1,16}/,
  /学习[\u4e00-\u9fa5A-Za-z0-9·]{1,16}/,
  /看(?!起来|上去|来|法|到|见|开|懂|透|清|一下|会)[\u4e00-\u9fa5A-Za-z0-9·]{1,16}/,
  /练(?!习惯|一下|会)[\u4e00-\u9fa5A-Za-z0-9·]{1,16}/,
  /背(?!锅|景|后|下来)[\u4e00-\u9fa5A-Za-z0-9·]{1,16}/,
  /写(代码|周报|作业|方案|文档|报告|论文)/,
  /做(作业|饭|题|计划|决定|项目)/,
  /开(会|晨会|例会)/,
  /学(习|英语|数学|单词)/,
  /背(单词|课文)/,
  /刷(题|视频)/,
  /跑(步|完步)/,
  /改(代码|文档|方案|报告)/,
  /打(球|电话)/,
  /通(电话|话)/,
  /看(电影|剧)/,
  /看(小说|动漫|动画|番剧)/,
  /(追番|追剧)/,
  /(睡觉了?|午睡了?)/,
  /(刷牙|洗漱|洗脸|护肤|化妆)/,
  /(洗头|洗衣服?|晾衣服?)/,
  /(收拾房间|打扫卫生|做家务|清洁)/,
  /(遛狗|逛超市)/,
  /(买咖啡|喝咖啡|喝水|接水)/,
  /([取拿寄]快递)/,
  /(点外卖|拿外卖)/,
  /(倒垃圾|洗碗)/,
  /(刷手机|看手机|看视频|听歌)/,
  /(打游戏|玩游戏)/,
  /(聊天|闲聊|唠嗑|连麦)/,
  /(约饭|干饭|聚会|聚餐)/,
  /(开黑|组队开黑)/,
  /(面基|逛街|压马路|探店|citywalk)/i,
  /(撸铁)/,
  /(做饭|买菜)/,
  /(坐(地铁|公交)|通勤(上班)?|赶路)/,
  /午休睡(了|得)/,
  /(打车|开车|骑车|骑行)/,
  /(拉伸|瑜伽|跳绳|跳操|游泳)/,
  /(羽毛球|篮球|足球|网球|乒乓球|徒步|爬山|登山)/,
  /(看展|看演出|看直播|刷短视频|听播客)/,
  /(k歌|唱歌|桌游|打牌)/i,
  /(约会|见朋友|探亲|串门|拜访)/,
  /(陪娃|带娃|接娃|送娃|喂猫|喂狗|遛猫|铲屎)/,
  /(泡澡|泡脚)/,
  /去洗个澡/,
  /到公司/,
  /出门了?/,
  /(上班|下班)(了|中)?/,
  /(上学|放学)(了|中)?/,
  /(上(线|号)|登(录|陆))(了)?/,
  /(开门|关门)(了)?/,
  /(上楼|下楼)(了)?/,
  /(下饺子|煮饺子|包饺子)/,
  /(开工|收工|到岗)(了)?/,
  /买到.+/,
  /刚把(作业|报告|文档|方案).*(交了|提交了)/,
  /做了(决定|选择|计划)/,
  /和(客户|朋友|家人).*(会开|开会|沟通|通话)/,
  /(在|刚在|正在)搞/,
  /搞定了?$/,
  /去健身房/,
  /(做|写)PPT/,
  /发邮件/,
  /回消息/,
  /写(测试|用例|文章|文档|脚本|总结)/,
  /(听|看)(课|讲座|播客)/,
  /(收|拆)快递/,
  /浇花/,
  /(换|洗)床单/,
  /修(东西|电脑|车|水管)/,
  /接(了)?(个)?(电话|客户电话)/,
  /产出(了)?.*文章/,
  /被老板骂/,
  /汇报通过/,
  /论文改(到)?崩溃/,
];

export const ZH_ACTIVITY_ONGOING_PATTERNS = [/(在|正在|刚在).*(开会|学习|复习|工作|上课|写|做|改|背单词|刷题)/, /(开会|学习|工作|上课|通话|会议|视频通话)中/];

export const ZH_STRONG_COMPLETION_PATTERNS = [
  /(刚|刚刚).*(开完|写完|做完|吃完|忙完|通完|打完).*/,
  /已经.*(开完|写完|做完|吃完|结束|搞定|完成|打完).*/,
  /(开完了|写完了|做完了|吃完了|结束了|搞定了|完成了|下课了|打完了|开完会了|考完了)$/,
  /(刚|刚刚).*(交了|提交了).*/,
  /(done with|finished)/i,
  /finito!?$/i,
];

export const ZH_WEAK_COMPLETION_WORDS = ['终于', '总算', '松口气', '撑过去'];

export const ZH_ACTIVITY_OBJECTS = [
  '早饭',
  '早餐',
  '午饭',
  '午餐',
  '晚饭',
  '晚餐',
  '夜宵',
  '便当',
  '零食',
  '面包',
  '牛奶',
  '酸奶',
  '鸡蛋',
  '米饭',
  '面条',
  '蛋白粉',
  '维生素',
  '药膏',
  '感冒药',
  '退烧药',
  '止痛药',
  '体检报告',
  '化验单',
  '核酸报告',
  '病历本',
  '处方单',
  '家务',
  '卫生',
  '桌面',
  '书桌',
  '阳台',
  '厨房',
  '卫生间',
  '冰箱',
  '油烟机',
  '空调',
  '风扇',
  '马桶',
  '地毯',
  '窗帘',
  '床垫',
  '枕套',
  '洗衣机',
  '烘干机',
  '电饭煲',
  '烤箱',
  '微波炉',
  '燃气',
  '水电费',
  '物业费',
  '房租',
  '账单明细',
  '账目',
  '账务',
  '流水',
  '支付记录',
  '付款单',
  '款项',
  '费用',
  '金额',
  '账户',
  '账号',
  '报销单',
  '预算表',
  '排期',
  '排班',
  '需求文档',
  '设计文档',
  '技术方案',
  '周计划',
  '月计划',
  '复盘文档',
  '知识库',
  '代码库',
  '仓库',
  '分镜',
  '文案',
  '推文',
  '稿子',
  '简报',
  '日报',
  '月报',
  '年报',
  '待办清单',
  '路线图',
  '时间表',
  '闹钟',
  '提醒事项',
  '公交',
  '地铁',
  '高铁',
  '航班',
  '出租车',
  '网约车',
  '单车',
  '头盔',
  '雨伞',
  '雨衣',
  '口粮',
  '猫条',
  '罐头',
  '逗猫棒',
  '遛狗绳',
  '作业本',
  '错题本',
  '答题卡',
  '试题',
  '成绩单',
  '考纲',
  '课程表',
  '笔袋',
  '中性笔',
  '铅笔',
  '橡皮',
  '尺子',
  '计算器',
  '充电宝',
  '蓝牙耳机',
  '投影仪',
  '路由器',
  '网线',
  '电池',
  '显示线',
  '教案',
  '课题',
  '开题',
  '提纲',
  '摘要',
  '附录',
  '讲座',
  '研讨会',
  '答辩',
  '实验',
  '实验报告',
  '实验数据',
  '公式',
  '图表',
  '表单',
  '问卷',
  '申请表',
  '报名表',
  '名片',
  '工牌',
  '会议纪要',
  '纪要',
  '流程图',
  '时序图',
  '原理图',
  '设计稿',
  '标注',
  '样机',
  '原件',
  '副本',
  '证书',
  '营业执照',
  '对账单',
  '税单',
  '收据',
  '订单',
  '购物清单',
  '待办',
  '日程',
  '日历',
  '提醒',
  '路线',
  '导航',
  '地图',
  '停车票',
  '取号单',
  '挂号单',
  '医保卡',
  '体温计',
  '药盒',
  '口罩',
  '牙线',
  '牙刷',
  '洗面奶',
  '洗发水',
  '沐浴露',
  '拖把',
  '抹布',
  '洗衣液',
  '柔顺剂',
  '消毒液',
  '纸巾',
  '垃圾袋',
  '快递单',
  '纸箱',
  '胶带',
  '剪刀',
  '螺丝',
  '扳手',
  '钳子',
  '充电线',
  '数据线',
  '鼠标',
  '键盘',
  '显示器',
  'U盘',
  '硬盘',
  '平板笔',
  '相机',
  '镜头',
  '三脚架',
  '自拍杆',
  '录音笔',
  '麦克风',
  '打印机',
  '打印纸',
  '墨盒',
  '书包',
  '背包',
  '行程单',
  '登机牌',
  '护照',
  '身份证',
  '银行卡',
  '门禁卡',
  '会员卡',
  '代金券',
  '优惠券',
  '账本',
  '收纳盒',
  '猫玩具',
  '狗绳',
  '猫碗',
  '狗碗',
  '猫砂盆',
  '宠物药',
  '奶瓶',
  '尿布',
  '玩具',
  '积木',
  '教材册',
  '练习册',
  '课外书',
  '英语书',
  '数学书',
  '历史书',
  '课本',
  '习题',
  '试卷',
  '真题',
  '单词',
  '词汇',
  '语法',
  '听力',
  '口语',
  '作文',
  '题库',
  '讲义',
  '笔试',
  '面试',
  '简历',
  '合同',
  '发票',
  '清单',
  '表格',
  '文献',
  '手册',
  '教程',
  '课件',
  '录音',
  '录像',
  '幻灯片',
  'PPT稿',
  '工单',
  'ticket',
  'PR',
  'MR',
  '分支',
  '脚本',
  '数据库',
  '接口',
  'API',
  '日志',
  '服务器',
  '容器',
  '镜像',
  '页面',
  '原稿',
  '草稿',
  '海报',
  '图片',
  '照片',
  '视频',
  '音频',
  '播客',
  '歌曲',
  '歌单',
  '电影',
  '剧',
  '番剧',
  '漫画',
  '小说',
  '杂志',
  '快递',
  '包裹',
  '外卖',
  '咖啡',
  '奶茶',
  '水果',
  '蔬菜',
  '食材',
  '锅',
  '碗',
  '盘子',
  '衣服',
  '鞋',
  '床单',
  '被套',
  '毛巾',
  '地板',
  '桌子',
  '窗户',
  '垃圾',
  '猫砂',
  '猫粮',
  '狗粮',
  '药品',
  '处方',
  '病例',
  '检查单',
  '牙套',
  '眼镜',
  '地铁卡',
  '公交卡',
  '车票',
  '机票',
  '行李',
  '证件',
  '钥匙',
  '钱包',
  '手机',
  '电脑',
  '平板',
  '耳机',
  '充电器',
  '水杯',
  '书',
  '超市',
  '商场',
  '街',
  '周报',
  '代码',
  '作业',
  '客户',
  '文档',
  '会议',
  '会',
  '方案',
  '项目',
  '报告',
  '饭',
  'PPT',
  '文章',
  '需求',
  '错题',
  '原型',
  '总结',
  '邮件',
  '消息',
  '笔记',
  '课',
  '资料',
  '代码',
  'bug',
  'Bug',
  'BUG',
  '测试',
  '论文',
  '汇报',
  '球',
  '报纸',
  '新闻',
  '日记',
  '账单',
  '笔记',
  '教材',
  '论文',
  '邮件',
  '会议',
  '视频会',
  '医生',
  '牙医',
  '体检',
  '药',
  '娃',
  '鱼',
  '车',
  // 乐器 / 舞蹈 / 手工对象（配合 verbs 弹/拉/跳/织/绣/折 做 verb+object 组合）
  '琴', '吉他', '钢琴', '尤克里里', '小提琴', '二胡', '笛子', '鼓', '萨克斯',
  '舞', '毛衣', '花', '纸',
];

export const ZH_PLACE_NOUNS = [
  '公园',
  '博物馆',
  '超市',
  '商场',
  '菜场',
  '便利店',
  '药店',
  '咖啡店',
  '餐厅',
  '食堂',
  '健身房',
  '球馆',
  '体育馆',
  '游泳馆',
  '火车站',
  '机场',
  '车站',
  '书店',
  '电影院',
  '剧院',
  '公寓',
  '小区',
  '银行',
  '政务大厅',
  '菜市场',
  '图书馆',
  '公司',
  '学校',
  '医院',
];

export const ZH_MOOD_WORDS = [...zhMood.allMoodWords];

export const ZH_MOOD_PATTERNS = [...zhMood.moodSentencePatterns];

export const ZH_EVALUATION_WORDS = [
  '终于',
  '总算',
  '可算',
  '太难了',
  '好爽',
  '好充实',
  '后悔',
  '不太对',
  '有成就感',
  '很有收获',
  '白忙了',
  '太值了',
  '太亏了',
  '好久没有',
  '上头',
  '踏实',
  '很崩',
];

export const ZH_LAST_ACTIVITY_REFERENCES = [
  '这件事',
  '这件事情',
  '这个',
  '刚才那个',
  '那个会',
  '那个电话',
  '那通电话',
  '那节课',
  '那次训练',
  '那个任务',
  '那份作业',
  '那次沟通',
  '那次会',
  '那通会',
  '那件活',
  '这波训练',
  '刚那节课',
  '刚才',
  '这种感觉',
];

export const ZH_FINISHING_PHRASES = ['做完了', '写完了', '结束了', '搞定了', '完成了', '弄完了', '看完了', '读完了', '上完线', '开完了', '开完会了', '下课'];

export const ZH_NEW_ACTIVITY_SWITCHES = ['然后', '接着', '后来去', '再去', '去'];

export const ZH_FUTURE_OR_PLAN_PATTERNS = [
  /明天.+/,
  /明天要.+/,
  /待会(儿)?(去|要)?/,
  /等下(去|要)?/,
  /一会(儿)?(去|要)?/,
  /晚点(去|要)?/,
  /准备去.+/,
  /要去.+/,
  /打算去.+/,
  /计划去.+/,
  /^(?!.*(?:刚|已经|了|完|过)).*想(?:去|吃|喝|做|干|看|听|玩|买|打|刷|练|考|学|写|上|下|回|睡|跑).+/,
];

export const ZH_NEGATED_OR_NOT_OCCURRED_PATTERNS = [
  /什么都不想做/,
  /什么都没做/,
  /(学|看|写|读).{0,3}不下去/,
  /(学|看|读).{0,3}不进去/,
  /(写|做|干).{0,3}不动(了)?/,
  /(做|干).{0,3}不下去/,
  /(学|看|写|做|干|读).{0,3}(提不起劲|提不起精神)/,
  /(学|看|写|做|干|读).{0,3}(没状态|没心情)/,
  /不想(开会|学习|上课|上班|运动|跑步|做|写)/,
  /想去.+但没去/,
  /(没|没有)去(过)?(公园|博物馆|超市|商场|菜市场|图书馆|公司|学校|医院)?/,
  /(今天)?(没有|没)产出/,
  /(今天)?(没有|没)进展/,
];

export const ZH_NON_ACTIVITY_PATTERNS = [
  ...ZH_FUTURE_OR_PLAN_PATTERNS,
  ...ZH_NEGATED_OR_NOT_OCCURRED_PATTERNS,
];

export const ZH_TRAILING_PARTICLES = /[啊呀呢吧嘛哦哈]$/g;

export const ZH_PUNCT_ONLY = /^[\p{P}\p{S}\s]+$/u;

export const ZH_MOOD_KEYWORDS: Array<{ pattern: RegExp; mood: MoodKey }> = [
  ...zhMood.explicitMoodMap,
];

export const ZH_CONTEXT_ACTIVITY_KEYWORDS = [
  ...ZH_ACTIVITY_STRONG_PHRASES,
  ...ZH_ACTIVITY_VERBS,
  ...ZH_ACTIVITY_OBJECTS,
  '开完',
  '写完',
  '做完',
  '吃完',
  '下课',
  '通话',
  '视频通话',
  '聚餐',
  '健身',
  '跑步',
  '周报',
  '报告',
  '作业',
  '会议',
].filter((token) => token.length >= 2);
